import { useTranslation } from "react-i18next"
import { EyedropperSample, X } from "@phosphor-icons/react"
import { Tag } from "@/components/ui/tag"
import {
  LaboratoryTest,
  VITAMIN_D_EXAMINATION_CODE,
} from "@/modules/patients/detail/laboratory-prescription/ch/constants"

type LaboratoryTestItemProps = {
  test: LaboratoryTest
  toggleOption: (option: LaboratoryTest) => void
}

const LaboratoryTestItem = ({ test, toggleOption }: LaboratoryTestItemProps) => {
  const { isFasted, translations } = test
  const { name, description } = translations || {}
  const { t } = useTranslation()

  return (
    <div className="group hover:bg-surface-hovered active:bg-surface-pressed flex min-h-12 w-full items-center gap-2 overflow-hidden rounded-md px-2 py-1 transition-all duration-300">
      <span>
        <EyedropperSample className="text-on-surface-subdued inline-block" />
      </span>
      <div className="w-full overflow-hidden">
        <p className="text-on-surface truncate text-sm leading-5 whitespace-nowrap" data-testid="laboratory-name">
          {name}
        </p>
        <p className="text-on-surface-subdued truncate text-xs leading-4 tracking-[0.25px]">{description}</p>
      </div>
      {isFasted && <Tag className="ml-auto" type="warning" label={t("patient.laboratoryPrescription.fasted")} />}
      {name?.includes(VITAMIN_D_EXAMINATION_CODE) && (
        <Tag className="ml-auto" type="warning" label={t("patient.laboratoryPrescription.attentionLimitation")} />
      )}
      <span
        className="text-on-surface-subdued hover:bg-surface-subdued-hovered hidden h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-full text-right transition-all duration-300 group-hover:flex"
        onClick={() => toggleOption(test)}>
        <X />
      </span>
    </div>
  )
}

export { LaboratoryTestItem }
